export const SITE_URL = "https://blvdsdetailing.com";
export const OG_IMAGE_URL = `${SITE_URL}/og-blvds-logo.jpg`;
export const DEFAULT_OG_TITLE = "BLVDS Detailing — NYC's Premier Mobile Car Detailing";
export const DEFAULT_OG_DESCRIPTION = "Showroom quality washes, full details, and ceramic coatings delivered right to your driveway. Book online in 60 seconds.";

// Local SEO — primary service area: NYC (Queens, Brooklyn) & Long Island
export const GEO_REGION = "US-NY";
export const GEO_PLACENAME = "Queens, Brooklyn & Long Island, New York";
export const GEO_POSITION = "40.7282;-73.7949"; // Queens centroid (approx)
export const ICBM = "40.7282, -73.7949";

export const LOCAL_GEO_META = [
  { name: "geo.region", content: GEO_REGION },
  { name: "geo.placename", content: GEO_PLACENAME },
  { name: "geo.position", content: GEO_POSITION },
  { name: "ICBM", content: ICBM },
] as const;

// Static social defaults — image, locale, card type. Per-page title/description/url
// must be set per-route via pageSocialMeta() so each page has unique social previews.
export const DEFAULT_SOCIAL_META = [
  { property: "og:image", content: OG_IMAGE_URL },
  { property: "og:image:width", content: "1200" },
  { property: "og:image:height", content: "630" },
  { property: "og:locale", content: "en_US" },
  { name: "twitter:image", content: OG_IMAGE_URL },
  { name: "twitter:card", content: "summary_large_image" },
] as const;

/**
 * Build per-page social meta tags. Use in each route's head().meta to give every
 * page a unique og:title, og:description, og:url, twitter:title, twitter:description.
 */
export function pageSocialMeta(path: string, title: string, description: string) {
  return [
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:url", content: canonicalUrl(path) },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
  ];
}

/**
 * Build a canonical URL for the given path (must start with "/").
 */
export function canonicalUrl(path: string): string {
  const clean = path === "/" ? "" : path.replace(/\/+$/, "");
  return `${SITE_URL}${clean}`;
}

/**
 * Returns a links array entry for the canonical tag — drop into a route's head().links.
 */
export function canonicalLink(path: string) {
  return { rel: "canonical", href: canonicalUrl(path) } as const;
}

/**
 * Build a BreadcrumbList JSON-LD object. Pass an ordered list of crumbs
 * starting from Home down to the current page.
 */
export function buildBreadcrumbJsonLd(
  crumbs: ReadonlyArray<{ name: string; path: string }>,
) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      item: `${SITE_URL}${c.path}`,
    })),
  };
}
